import { ReactElement } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { FieldErrors, get } from "react-hook-form";
import "./styling/styling.scss";
import { intl } from "LocaleWrapper";

const FormField = ({ children, errors, name = "", min, max, minLength, maxLength, validation }: {
	children: ReactElement | ReactElement[],
	errors?: FieldErrors,
	name?: string,
	min?: number,
	max?: number,
	minLength?: number,
	maxLength?: number,
	validation?: string,
}) => {

	const error = errors && get(errors, name);

	return (
		<div className={`cck-form-field ${error ? "error" : ""}`}>
			{children}

			{error && (
				<div className='form-field-error'>
					{![ "required", "min", "max", "minLength", "maxLength", "validate", "custom", "invalid_type" ].includes(error?.type) && <ErrorMessage name={name} errors={errors} />}
					{(error?.type === "required" || error?.type === "invalid_type") && <ErrorMessage errors={errors} name={name} message={ intl.formatMessage({ id: "REQUIRED" })} />}
					{error?.type === "min" && <ErrorMessage errors={errors} name={name} message={`Value should be greater than ${min}`} />}
					{error?.type === "max" && <ErrorMessage errors={errors} name={name} message={`Value should not be greater than ${max}`} />}
					{error?.type === "minLength" && <ErrorMessage errors={errors} name={name} message={`Text should be greater than ${minLength} characters`} />}
					{error?.type === "maxLength" && <ErrorMessage errors={errors} name={name} message={`Text should not be greater than ${maxLength} characters`} />}
					{(error?.type === "validate" || error?.type === "custom") && <ErrorMessage errors={errors} name={name} message={validation} />}
				</div>
			)}
		</div>
	);
};

export default FormField;
